// extracted by mini-css-extract-plugin
module.exports = {"Background":"Navbar_Background__35eA7","Position":"Navbar_Position__1qiia"};